<template>
  <!-- Modal Component -->
  <b-modal
    id="modal_buscarpedidounidadecargatrecho"
    ref="modal_buscarpedidounidadecargatrecho"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    v-model="showModalBuscarPedidoUnidadeCargaTrecho"
    :ok-disabled="form.errors.any()"
    size="lg"
  >
    <b-container fluid class="p-a-0">
      <form
        @submit.stop.prevent="handleOk"
        @keydown="form.errors.clear($event.target.name)"
      >
        <div v-if="vuetableFilterRow">
          <vuetable-filterbar :tabela="'peduncatr_id'"> </vuetable-filterbar>
        </div>
        <div class="loadingDataPosition">
          <div class="loadingData" v-if="loadingPedidoUnidadeCargaTrecho">
            <div class="loadingDataSpinner">
              <spinner
                v-if="loadingPedidoUnidadeCargaTrecho"
                text-fg-color="#ffffff"
                message="Carregando..."
              ></spinner>
            </div>
          </div>
          <vuetable
            ref="vuetable"
            api-url="/api/faturadespesa/trecho/index"
            :fields="fields"
            :css="css"
            :append-params="moreParams"
            track-by="peduncatr_id"
            pagination-path=""
            @vuetable:pagination-data="onPaginationData"
            @vuetable:loaded="onLoaded"
          >
            <template slot="transportadora" slot-scope="props">
              <span
                v-if="
                  props.rowData.fornecedor != null &&
                    props.rowData.fornecedor.pessoa_juridica != null
                "
                >{{
                  props.rowData.fornecedor.pessoa_juridica.razao_social
                }}</span
              >
            </template>
            <template slot="carga" slot-scope="props">
              <span>{{ props.rowData.num_carga }}</span>
            </template>
            <template slot="vlr_custo_total" slot-scope="props">
              <span>{{ formatNumber(props.rowData.vlr_custo) }}</span>
            </template>
          </vuetable>
        </div>
        <div>
          <div class="col-md-12">
            <div class="pull-left pagination-detail">
              <vuetable-pagination-info
                ref="paginationInfo"
                :css="css.pagination"
                info-class="pull-left"
              ></vuetable-pagination-info>
            </div>
            <div class="pull-right m-a-0">
              <vuetable-pagination
                ref="pagination"
                :css="css.pagination"
                @vuetable-pagination:change-page="onChangePage"
              ></vuetable-pagination>
            </div>
          </div>
        </div>
      </form>
    </b-container>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Associando..."></spinner>
      </div>
      <div class="float-right">
        <div class="float-left" v-if="this.errors_array.length > 0">
          <b-btn
            class="badge badge-warning"
            @click="showPopover = !showPopover"
            id="popoverButton-sync"
            v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'"
            variant="warning"
            ><i class="fa fa-exclamation-triangle fa-2x"></i
          ></b-btn>

          <b-popover
            :show.sync="showPopover"
            target="popoverButton-sync"
            title="<strong>Erros Encontrados</strong>"
            data-html="true"
            placement="leftbottom"
          >
            <table class="table" id="mais">
              <tbody></tbody>
            </table>
          </b-popover>
        </div>
        &nbsp;

        <b-btn
          @click="showModalBuscarPedidoUnidadeCargaTrecho = false"
          variant="secondary"
        >
          Voltar
        </b-btn>
        <b-btn @click="onStore()" variant="primary" :disabled="isDisabled">
          Vincular
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Vuetable from "./Vuetable";
import VuetablePagination from "./VuetablePagination";
import VuetablePaginationInfo from "./VuetablePaginationInfo";
import BuscarPedidoUnidadeCargaTrechoFilterBar from "./BuscarPedidoUnidadeCargaTrechoFilterBar";
// import BuscarDocFiscalDetalhes from './BuscarDocFiscalDetalhes'
import accounting from "accounting";
import { VMoney } from "v-money";
import moment from "moment";

export default {
  components: {
    VMoney,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    "vuetable-filterbar": BuscarPedidoUnidadeCargaTrechoFilterBar,
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingPedidoUnidadeCargaTrecho: true,
      showPopover: false,
      showModalBuscarPedidoUnidadeCargaTrecho: false,
      trechos: [],
      parmot_id: "",
      errors_array: [],
      form: new Form({
        cst: [],
        chave_cte_multi: "",
        chave: "",
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:carga",
          title: "Carga",
          sortField: "carga",
        },
        {
          name: "num_trecho",
          title: "N° do Trecho",
          sortField: "num_trecho",
        },
        {
          name: "__slot:transportadora",
          title: "Transportadora",
          sortField: "transportadora",
        },
        {
          name: "__slot:vlr_custo_total",
          title: "Valor do Calculo",
          sortField: "vlr_custo_total",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
        detailRowClass: "vuetable-detail-row",
      },
      moreParams: new Form({        
        param_motivo: "",
      }),
    };
  },
  directives: {
    money: VMoney,
    aliquota: VMoney,
    qtd: VMoney,
    percentual_reducao_bc: VMoney,
  },
  mounted() {
    this.$events.$on("filterModal-set", (eventData) =>
      this.onFilterSet(eventData)
    );
    this.$events.$on("filterModal-reset", (e) => this.onFilterReset());
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingPedidoUnidadeCargaTrecho = true;
      this.moreParams = {
        num_carga: data_filter.num_carga,
        num_trecho: data_filter.num_trecho,
        dt_inicio: data_filter.dt_inicio,
        dt_fim: data_filter.dt_fim,
        transportadora: data_filter.transportadora.value,
        param_motivo: this.parmot_id
      };
      
      //Colocado setTimeout pois o nextTick estava sendo chamado antes do DOM atualizar
      setTimeout(() => {
        Vue.nextTick(() => this.$refs.vuetable.refresh());
      }, 100);
      
    },
    onFilterReset() {
      console.log("Entrou no Reset");
      this.loadingPedidoUnidadeCargaTrecho = true;
      this.moreParams = {
        param_motivo: this.parmot_id
      };
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function() {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingPedidoUnidadeCargaTrecho = false;
      this.$store.commit("setVuetableFilterButton", false);

      if (this.trechos) {
        this.trechos.forEach((obj) => {
          this.$refs.vuetable.selectedTo.push(parseFloat(obj.id));
        });
      }
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.docfis_id);
    },
    formatDate(value, fmt = "D MMM YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onBuscarPedidoUnidadeCargaTrecho(data, trechos, parmot_id) {
      this.loadingPedidoUnidadeCargaTrecho = true;
      this.modal_titulo = "Buscar Trechos";
      this.modal_botao = "Associar";
      this.modal_acao = "i";
      this.form.reset();
      this.moreParams = {};
      this.trechos = trechos;
      this.moreParams.param_motivo = parmot_id;
      this.parmot_id = parmot_id;

      this.$refs.modal_buscarpedidounidadecargatrecho.show();
    },
    onStore() {
      this.trechos = null;
      this.trechos = [];
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.$refs.vuetable.tableData.forEach((obj2) => {
          if (obj2.peduncatr_id == obj) {
            this.trechos.push({
              id: obj2.peduncatr_id,
              vlr_custo: obj2.vlr_custo,
              transportadora:  obj2.fornecedor != null &&
                obj2.fornecedor.pessoa_juridica != null ? obj2.fornecedor.pessoa_juridica.razao_social : null
            });
          }
        });
      });
      this.$parent.onAssociarTrecho(this.trechos);
      this.onFilterReset()
      this.showModalBuscarPedidoUnidadeCargaTrecho = false;
      
    },
    onVoltar() {
      this.onFilterReset();
      this.$refs.modal_buscadocfiscal.hide();
    },
    formatNumberInterno(value) {
      return accounting.formatNumber(value, 2, ",", ".");
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatNumberQtd(value) {
      return accounting.formatNumber(value, 3, ".", ",");
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    handleOk(e) {},
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
